import { useContext } from 'react';
import { GroupEntityTagsContext } from '../context';

export default function useGroupEntityTags() {
  const value = useContext(GroupEntityTagsContext);
  return value;
}

export { useGroupEntityTags };